import { globalEntitlements } from '../utils/globalEntitlements';

/** @typedef {import('../types').ProductLandingConfig} ProductLandingConfig */

/** @type {ProductLandingConfig} */
export const VELO_PRIME_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.veloPrime.buyBox.bulletPoint1' },
          { title: 'productPage.veloPrime.buyBox.bulletPoint2' },
          { title: 'productPage.veloPrime.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.veloPrime.buyBox.productName',
        productBadge: 'productPage.veloPrime.buyBox.badge',
        interactService: {
          ctaType: 'externalCheckout',
          service: 'velo_prime',
          openInNewTab: true,
        },
      },
    ],
    headerPicture: {
      src: 'https://res.cloudinary.com/zenbusiness/image/upload/q_auto,w_1200/shared-assets/wp_img/other/cofounder-static.png',
      alt: 'productPage.veloPrime.heroPicture.altText',
    },
    headline: 'productPage.veloPrime.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.veloPrime.page.subheader',
  },
  benefit: {
    title: 'productPage.veloPrime.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/forumrounded.svg',
        title: 'productPage.veloPrime.valueProp.propTitle1',
        description: 'productPage.veloPrime.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/bedtimerounded.svg',
        title: 'productPage.veloPrime.valueProp.propTitle2',
        description: 'productPage.veloPrime.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/campaignrounded.svg',
        title: 'productPage.veloPrime.valueProp.propTitle3',
        description: 'productPage.veloPrime.valueProp.shortCopy3',
      },
    ],
  },
  howItWorks: {
    title: 'productPage.veloPrime.howItWorks.title',
    items: [
      { title: 'productPage.veloPrime.howItWorks.step1' },
      { title: 'productPage.veloPrime.howItWorks.step2' },
      { title: 'productPage.veloPrime.howItWorks.step3' },
      { title: 'productPage.veloPrime.howItWorks.step4' },
    ],
    image:
      'https://res.cloudinary.com/zenbusiness/image/upload/q_auto,w_900/shared-assets/wp_img/other/approve-does-rest.png',
    alt: 'productPage.veloPrime.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.veloPrime.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.veloPrime.frequentlyAskedQuestions.faq1',
        answer: 'productPage.veloPrime.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.veloPrime.frequentlyAskedQuestions.faq2',
        answer: 'productPage.veloPrime.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.veloPrime.frequentlyAskedQuestions.faq3',
        answer: 'productPage.veloPrime.frequentlyAskedQuestions.faqAnswer3',
      },
      {
        question: 'productPage.veloPrime.frequentlyAskedQuestions.faq4',
        answer: 'productPage.veloPrime.frequentlyAskedQuestions.faqAnswer4',
      },
    ],
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.veloPrime.buyBox.buttonLabel',
  })
    .allowMultiplePurchases()
    .build(),
};
